import {html} from 'lit';
import Base from '../base.js';
import styles from './dropdown-item.css' assert {type: 'css'};

/**
 * @element inv-dropdown-item
 *
 * @class DropdownItem
 * @classdesc This is a web component that creates a dropdown item.
 *
 * @property {string|null} value - The value of the dropdown item.
 * @property {string} label - The label of the dropdown item.
 *
 * @cssproperty --inv-dropdown-item-padding-y
 * @description The vertical padding of the dropdown item.
 * @type {string}
 * @default 0.25em
 *
 * @cssproperty --inv-dropdown-item-padding-x
 * @description The horizontal padding of the dropdown item.
 * @type {string}
 * @default 1em
 *
 * @cssproperty --inv-dropdown-link-color
 * @description The color of the dropdown item link.
 * @type {string}
 * @default #212529
 *
 * @cssproperty --inv-dropdown-link-hover-color
 * @description The color of the dropdown item link on hover.
 * @type {string}
 * @default #1e2125
 *
 * @cssproperty --inv-dropdown-link-hover-background
 * @description The background color of the dropdown item on hover.
 * @type {string}
 * @default #e9ecef
 *
 * @cssproperty --inv-dropdown-link-active-color
 * @description The color of the active dropdown item link.
 * @type {string}
 * @default #fff
 *
 * @cssproperty --inv-dropdown-link-active-background
 * @description The background color of the active dropdown item.
 * @type {string}
 * @default #0d6efd
 *
 * @cssproperty --inv-dropdown-link-disabled-color
 * @description The color of the disabled dropdown item link.
 * @type {string}
 * @default #adb5bd
 */
export default class DropdownItem extends Base {
    static get properties() {
        return {
            value: {
                type: String,
            },
            label: {
                type: String,
            },
        };
    }

    constructor() {
        super();
        this.value = null;
        this.label = 'None';
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    render() {
        return html`
            <li>
                <a class="dropdown-item">${this.label}</a>
            </li>
        `;
    }
}

DropdownItem.register();
